module.exports = __webpack_public_path__ + "static/media/0029_LES_MURS_HARMONIE_1.caa81ce4.png";